export const TEST_ID = 'spraySettingsSection';

export const SPRAY_TITLE = 'Spray Settings';

export const SPREAD_TITLE = 'Spread Settings';

export const LABELS = {
    applicationType: 'Application Type',
    groundSpeed: 'Ground Speed (mph)',
    nozzlePercentage: 'Nozzle %',
    passOverlap: 'Pass Overlap (ft)',
    productCategory: 'Product Category',
    sprayRate: 'Spray Rate (gal/ac)',
    spraySettings: 'Spray Settings',
    spreadRate: 'Spread Rate (lb/ac)',
    turntablePercentage: 'Turntable %'
};

export const APPLICATION_TYPE_SPRAY = 'SPRAY';

export const APPLICATION_TYPE_SPREAD = 'SPREAD';

export const APPLICATION_TYPE_OPTIONS = [
    { label: 'Spray', value: APPLICATION_TYPE_SPRAY },
    { label: 'Spread', value: APPLICATION_TYPE_SPREAD }
];

export const APPLICATION_TYPE_SPRAY_INDEX = 0;

export const APPLICATION_TYPE_SPREAD_INDEX = 1;

export const PRODUCT_CATEGORY_OPTIONS = [
    { label: 'Fungicide', value: 'FUNGICIDE' },
    { label: 'Herbicide', value: 'HERBICIDE' },
    { label: 'Insecticide', value: 'INSECTICIDE' },
    { label: 'Miticide', value: 'MITICIDE' },
    { label: 'Nutrient', value: 'NUTRIENT' },
    { label: 'Organic', value: 'ORGANIC' },
    { label: 'Other', value: 'OTHER' }
];

export const GROUND_SPEED = { max: 44, min: 0, step: 0.5 };

export const GROUND_SPEED_METRIC_MAX = 20;

export const OVERLAP_METERS = { max: 98, min: 0, step: 0.5 };

export const OVERLAP_METERS_METRIC_MAX = 30;

export const SPRAY_RATE = { max: 64, min: 0, step: 0.5 };

export const SPRAY_RATE_METRIC_MAX = 600;

export const NOZZLE_PERCENTAGE = { max: 100, min: 0, step: 1 };

export const SPREAD_RATE = { max: 53, min: 0, step: 0.5 };

export const SPREAD_RATE_METRIC_MAX = 60;

export const TURNTABLE_PERCENTAGE = { max: 100, min: 0, step: 1 };
